<template>
  <SidebarComponent />
  <div class="dashboard-layout staff-ticket-mobile">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Tickets tecnici aperti</h1>
        </div>
        <div class="loader" v-if="isLoading">
          <h4>RECUPERO DEI TICKETS TECNICI IN CORSO</h4>
        </div>

        <div class="search-container staff-ticket-search">
  <input type="text" v-model="searchKeyword" placeholder="Cerca nelle conversazioni..." class="search-bar">
  <button aria-label="Filtri ticket" @click="openFiltriContactModal" class="create-user-button staff-button-neutral"><span class="material-icons">tune</span></button>
  <button aria-label="Aggiorna ticket" @click="refreshSlot" class="create-user-button staff-button-neutral"><span class="material-icons">autorenew</span></button>

  <!-- Nuovo bottone per aprire il modale con 5 link e testo -->
  <button @click="openLinksModal" class="create-user-button staff-button-neutral">
    <span class="material-icons">link</span> Note e link
  </button>

  <button @click="goToUsers" class="create-user-button2">Ricerca Utenti</button>

</div>


        <div class="tickets staff-ticket-list">
          <div>
            <table class="staff-ticket-table" aria-label="Ticket tecnici" role="table">
              <thead role="rowgroup">
                <tr role="row">
                  <th scope="col" role="columnheader"></th>
                  <th scope="col" role="columnheader">DATA</th>
                  <th scope="col" role="columnheader">STATO</th>
                  <th scope="col" role="columnheader">TIPOLOGIA</th>
                  <th scope="col" role="columnheader">PROGRAMMA</th>
                  <th scope="col" role="columnheader">STUDIO</th>
                  <th scope="col" role="columnheader" class="order-column">ORDINE</th>
                  <th scope="col" role="columnheader">EMAIL</th>
                  <th scope="col" role="columnheader">NOME E COGNOME</th>
                  <th scope="col" role="columnheader"></th>
                  <th scope="col" role="columnheader"></th>
                </tr>
              </thead>
              <tbody role="rowgroup">
                <tr role="row"
                  v-for="ticket in filteredTickets"
                  :key="ticket.id"
                  :class="{ 'flagged-ticket': ticket.flagged }"
                  style="cursor: pointer;"
                >
                  <td class="staff-ticket-actions-cell" data-label="Azioni" role="cell">
                    <div class="buttons-container">
                      <input aria-label="Seleziona ticket" type="checkbox" class="custom-checkbox" v-model="selectedTickets" :value="ticket.id">
                      <button class="technical-ticket-notification-action" @click.stop="confirmSendNotification(ticket.userId)" title="Invia Notifica">
                        <span class="material-icons">notifications</span>
                      </button>
                    </div>
                    <span v-if="ticket.flagged" class="flag-indicator">In evidenza</span>
                  </td>
                  <td class="staff-ticket-date-cell data-column" data-label="Ultimo aggiornamento" role="cell">{{ ticket.lastUpdate }}</td>
                  <td class="technical-ticket-state-cell" data-label="Stato" role="cell">
                    <span class="technical-ticket-state" :class="ticketStatusClass(ticket)">{{ ticket.status || 'Stato non disponibile' }}</span>
                    <span v-if="ticket.read === true || ticket.read === 'true'" class="technical-ticket-read-indicator">
                      <span class="material-icons" aria-hidden="true">visibility</span> Letto
                    </span>
                    <span v-else class="technical-ticket-read-indicator technical-ticket-read-indicator--unread">Non letto</span>
                  </td>
                  <td class="staff-ticket-status-cell data-column" data-label="Tipologia" role="cell">
                    <select aria-label="Tipologia ticket" :value="ticket.tipoTicket" :disabled="ticketTypeSaving[ticket.id]" @change="updateTipoTicket(ticket, $event)">
                      <option value=""></option>
                      <option value="Commerciale">Commerciale</option>
                      <option value="Tecnico">Tecnico</option>
                      <option value="Ibrido">Ibrido</option>
                      <option value="In attesa">In attesa di risposta</option>

                    </select>
                    <span v-if="ticketTypeSaving[ticket.id]" class="technical-ticket-category-feedback" role="status">Salvataggio…</span>
                    <span v-else-if="ticketTypeErrors[ticket.id]" class="technical-ticket-category-feedback technical-ticket-category-feedback--error" role="alert">{{ ticketTypeErrors[ticket.id] }}</span>
                  </td>
                  <td class="technical-ticket-programme-cell" data-label="Programma" role="cell">
                    <span
                      v-for="programme in ticketProgrammeStatus(ticket)"
                      :key="programme.key"
                      class="technical-ticket-programme"
                      :class="`technical-ticket-programme--${programme.state}`"
                      :title="programme.details"
                      :aria-label="programme.details"
                    >{{ programme.label }}</span>
                  </td>
                  <td class="staff-ticket-studio-cell" data-label="Studio" role="cell">{{ ticket.userStudio }}</td>
                  <td class="staff-ticket-order-cell order-cell" data-label="Ordine" role="cell">
                    <button
                      type="button"
                      class="order-badge"
                      :class="`order-badge--${ticketOrderBadgeStatus(ticket)}`"
                      @click.stop="showTicketOrder(ticket)"
                      title="Mostra ultimo ordine"
                      aria-label="Mostra ultimo ordine"
                    >
                      <span class="material-icons" aria-hidden="true">receipt_long</span>
                    </button>
                  </td>
                  <td class="staff-ticket-email-cell email-cell" data-label="Email" role="cell">
                    <span class="email-text staff-ticket-desktop-only" :title="ticket.userEmail || '—'">
                      {{ formatEmail(ticket.userEmail) }}
                    </span>
                    <span class="staff-ticket-mobile-only">{{ ticket.userEmail || '—' }}</span>
                  </td>
                  <td class="staff-ticket-name-cell" data-label="Nome e cognome" role="cell">{{ ticket.userName }} {{ ticket.userSurname }}</td>
                  <td class="staff-ticket-open-cell" data-label="Conversazione" role="cell">
                    <button class="staff-ticket-open-button" aria-label="Apri conversazione" :class="ticketStatusClass(ticket)"
                            @click.stop="viewConversation(ticket.id)">
                      <span class="staff-ticket-mobile-only">Apri conversazione</span>
                      <span class="material-icons" aria-hidden="true">chevron_right</span>
                    </button>
                  </td>
                  <td class="staff-ticket-count-cell" data-label="Messaggi" role="cell">{{ ticket.conversations.length }}</td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal" v-if="showOrderModal">
    <div class="modal-content order-modal">
      <span class="close" @click="closeOrderModal">&times;</span>
      <h2>Ultimo ordine</h2>

      <div v-if="orderLoading" class="order-loader">Caricamento…</div>
      <div v-else-if="orderError" class="order-error">{{ orderError }}</div>
      <div v-else-if="orderSummary" class="order-card">
        <div class="order-card__body">
          <div class="order-field">
            <span class="order-field__label">Codice</span>
            <span class="order-field__value">{{ orderSummary.code }}</span>
          </div>
          <div class="order-field">
            <span class="order-field__label">Data</span>
            <span class="order-field__value">{{ orderSummary.date }}</span>
          </div>
          <div class="order-field" v-if="orderSummary.status && orderSummary.status !== '—'">
            <span class="order-field__label">Stato</span>
            <span class="order-field__value">{{ orderSummary.status }}</span>
          </div>
          <div class="order-field">
            <span class="order-field__label">Totale</span>
            <span class="order-field__value">{{ orderSummary.total }}</span>
          </div>
          <div class="order-field order-field--products" v-if="orderSummary.products.length">
            <span class="order-field__label">Prodotti</span>
            <ul class="order-products">
              <li
                v-for="(product, index) in orderSummary.products"
                :key="index"
                :class="productHighlightClass(product)"
              >
                {{ product }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else class="order-empty">Nessun ordine trovato per questo utente.</div>
    </div>
  </div>

  <!-- Modal per i filtri -->
  <div class="modal" v-if="showModal">
    <div class="modal-content">
      <span class="close" @click="closeModal">&times;</span>
      <h2>Filtri Contatto</h2>

      <select v-model="filterByStudio" @change="updateFilterByStudio">
  <option value="">Seleziona Studio</option>
  <option value="Tivoli Quartier generale">Tivoli Quartier generale</option>
  <option value="FF Genova">FF Genova</option>
  <option value="FF Bologna">FF Bologna</option>
  <option value="FF Bari">FF Bari</option>
  <option value="FF Pescara">FF Pescara</option>
  <option value="FF Firenze">FF Firenze</option>
  <option value="FF Torino">FF Torino</option>
  <option value="FF Napoli">FF Napoli</option>
  <option value="FF Milano">FF Milano</option>
  <option value="FF Milano Sempione">FF Milano Sempione</option>
  <option value="FF Milano Citta Studi">FF Milano Città Studi</option>
  <option value="FF Roma">FF Roma</option>
  <option value="FF Roma Eur">FF Roma Eur</option>
  <option value="FF Salerno">FF Salerno</option>
  <option value="FF Cagliari">FF Cagliari</option>
  <option value="FF Padova">FF Padova</option>
  <option value="undefined">Nessuno Studio</option>
</select>


      <select v-model="filterByTipoTicket" @change="updateFilterByTipoTicket">
  <option value="">Seleziona Tipo Ticket</option>
  <option value="Commerciale">Commerciale</option>
  <option value="Tecnico">Tecnico</option>
  <option value="Ibrido">Ibrido</option>
</select>


      <div>
        <button @click="resetFilters" class="create-reset-button">Reset Filtri</button>
      </div>
    </div>
  </div>

  <!-- Modal per selezionare cliente e inviare messaggio -->
  <div class="modal" v-if="showModal2">
    <div class="modal-content">
      <span class="close" @click="closeClientModal">&times;</span>
      <h2>Seleziona Cliente e Invia Messaggio</h2>

      <div class="search-field">
        <input type="text" v-model="debouncedSearchClientEmail" placeholder="Cerca per email..." class="search-bar">
        <input type="text" v-model="debouncedSearchClientSurname" placeholder="Cerca per cognome..." class="search-bar">
        <button @click="onSearchClick">Cerca</button>
      </div>

      <div v-if="users.length > 0">
        <p>Clicca su un contatto per selezionarlo:</p>
        <div v-for="user in filteredUsers" :key="user.id" class="user-item" @click="selectUser(user)">
          <span>{{ user.name }} {{ user.surname }} - {{ user.email }} - {{ user.phone }}</span>
        </div>
      </div>

      <div v-if="selectedUser">
        <h3>Scrivi a {{ selectedUser.name }} {{ selectedUser.surname }}</h3>
        <input type="text" v-model="title" placeholder="Titolo del messaggio" class="message-title" />
        <textarea v-model="message" placeholder="Scrivi il tuo messaggio..." class="message-textarea"></textarea>
        <button @click="createTicket" class="send-button" :disabled="isCreatingTicket">{{ isCreatingTicket ? 'Invio in corso…' : 'Invia Messaggio' }}</button>
      </div>
    </div>
  </div>

<!-- Modale con 5 link e testo -->
<div class="modal" v-if="showLinksModal">
  <div class="modal-content">
    <span class="close" @click="closeLinksModal">&times;</span>
    <h2>Note e link</h2>
    <p>In questa sezione possiamo posizionare link e testo, utile alle risposte:
    </p>
    <ul>
      <li>
        <a href="https://bit.ly/4baLFsa" target="_blank">Installazione app IOS</a>
        <button @click="copyToClipboard('https://bit.ly/4baLFsa')">Copia</button>
      </li>
      <li>
        <a href="https://bit.ly/4be22nU" target="_blank">Registrazione ed accesso utente</a>
        <button @click="copyToClipboard('https://bit.ly/4be22nU')">Copia</button>
      </li>
      <li>
        <a href="https://bit.ly/3XqoxCO" target="_blank">Recupera Password</a>
        <button @click="copyToClipboard('https://bit.ly/3XqoxCO')">Copia</button>
      </li>
      <li>
        <a href="https://bit.ly/3Vz0IpD" target="_blank">Apertura ticket assistenza</a>
        <button @click="copyToClipboard('https://bit.ly/3Vz0IpD')">Copia</button>
      </li>
    </ul>
  </div>
</div>


<!-- Modale per Visualizzare Statistiche -->
<div class="modal" v-if="showStatsModal">
  <div class="modal-content">
    <span class="close" @click="closeStatsModal">&times;</span>
    <h2>Statistiche Tickets</h2>
    <div>
      <p>Totale Aperto: {{ stats.aperto }}</p>
      <p>Totale Risposto: {{ stats.risposto }}</p>
      <p>Totale Non Risposto: {{ stats.nonRisposto }}</p>
    </div>
  </div>
</div>

</template>


<script>
import { useStore } from 'vuex';
import { onMounted, ref, computed, onBeforeUnmount, watch } from 'vue';
import { useRouter } from 'vue-router';
import { getFirestore, Timestamp, query, collection, where, getDocs, getDoc, updateDoc, doc, onSnapshot, deleteDoc, documentId, runTransaction, serverTimestamp } from 'firebase/firestore';
import SidebarComponent from '../SidebarComponent.vue';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useOrderBadge } from '@/composables/useOrderBadge';
import { toDateValue, getTicketLastActivityMs, buildTechnicalMessageKey } from '@/lib/technicalConversation';
import { createTechnicalTicket, createTechnicalMessageId } from '@/lib/technicalTicketMessages';
import { useTicketProgrammeStatus } from '@/composables/useTicketProgrammeStatus';

export default {
  components: {
    SidebarComponent
  },
  setup() {
    const db = getFirestore();
    const tickets = ref([]);
    const ticketTypeSaving = ref({});
    const ticketTypeErrors = ref({});
    const { ticketProgrammeStatus } = useTicketProgrammeStatus(db, tickets);
    const unsubscribeFns = [];
    const showModal = ref(false);
    const showModal2 = ref(false);
    const showLinksModal = ref(false);
    const showStatsModal = ref(false);
    const users = ref([]);
    const selectedUser = ref(null);
    const title = ref('');
    const message = ref('');
    const isCreatingTicket = ref(false);
    let pendingTicketDraft = null;
    const searchClientEmail = ref('');
    const searchClientSurname = ref('');
    const debouncedSearchClientEmail = ref('');
    const debouncedSearchClientSurname = ref('');
    const isLoading = ref(false);
    const router = useRouter();
    const searchEmail = ref('');
    const searchSurname = ref('');
    const searchDate = ref('');
    const searchKeyword = ref('');
    const filterByMultipleTickets = ref(false);
    const filterByTipoTicket = ref('');

    const {
      showOrderModal,
      orderLoading,
      orderError,
      selectedOrder,
      orderSummary,
      openLastOrder,
      closeOrderModal,
      orderBadgeStatus,
      productHighlightClass,
      prefetchUserHighlights
    } = useOrderBadge();

    const userCache = new Map();
    const pendingUserIds = new Set();
    let userFetchTimeout = null;

    const applyUserDetailsToTicket = (ticket, userData) => {
      if (!ticket) return;
      if (userData) {
        ticket.userEmail = userData.email || 'Email sconosciuta';
        ticket.userName = userData.name || 'Nome sconosciuto';
        ticket.userSurname = userData.surname || 'Cognome sconosciuto';
        ticket.userStudio = userData.studio || 'Studio sconosciuto';
      }
    };

    const queueOrderPrefetch = (userId, email) => {
      const normalizedEmail = email ? email.trim().toLowerCase() : '';
      if (!normalizedEmail || prefetchedOrderEmails.has(normalizedEmail)) return;
      prefetchedOrderEmails.add(normalizedEmail);
      prefetchUserHighlights([{ uid: userId, email }]).catch((error) => {
        console.error('Errore nel prefetch degli ordini per', email, error);
      });
    };

    const updateTicketsWithUserData = (userId, userData) => {
      let hasEmail = false;
      for (let i = 0; i < tickets.value.length; i += 1) {
        const ticket = tickets.value[i];
        if (ticket.userId === userId) {
          applyUserDetailsToTicket(ticket, userData);
          hasEmail = hasEmail || !!userData?.email;
        }
      }
      if (userData?.email && hasEmail) {
        queueOrderPrefetch(userId, userData.email);
      }
    };

    const processPendingUsers = async () => {
      const idsToFetch = Array.from(pendingUserIds);
      pendingUserIds.clear();
      userFetchTimeout = null;

      if (!idsToFetch.length) {
        return;
      }

      const usersCollection = collection(db, 'users');
      const chunkSize = 10;

      for (let start = 0; start < idsToFetch.length; start += chunkSize) {
        const chunk = idsToFetch.slice(start, start + chunkSize);
        try {
          const q = query(usersCollection, where(documentId(), 'in', chunk));
          const snapshot = await getDocs(q);
          const fetchedIds = new Set();

          snapshot.forEach((docSnap) => {
            const data = docSnap.data();
            userCache.set(docSnap.id, data);
            fetchedIds.add(docSnap.id);
            updateTicketsWithUserData(docSnap.id, data);
          });

          chunk.forEach((userId) => {
            if (!fetchedIds.has(userId)) {
              userCache.set(userId, null);
            }
          });
        } catch (error) {
          console.error('Errore nel recupero batch utenti:', error);
          chunk.forEach((userId) => pendingUserIds.add(userId));
        }
      }

      if (pendingUserIds.size) {
        userFetchTimeout = setTimeout(processPendingUsers, 100);
      }
    };

    const enqueueUserDetailFetch = (userId) => {
      if (!userId || userCache.has(userId) || pendingUserIds.has(userId)) {
        return;
      }
      pendingUserIds.add(userId);
      if (!userFetchTimeout) {
        userFetchTimeout = setTimeout(processPendingUsers, 50);
      }
    };

    const ticketOrderEmail = (ticket) => {
      const rawEmail = (ticket.userEmail || '').trim();
      if (!rawEmail || rawEmail === 'Caricamento...' || rawEmail === 'Email sconosciuta') {
        return '';
      }
      return rawEmail.includes('@') ? rawEmail : '';
    };

    const showTicketOrder = (ticket) => {
      const email = ticketOrderEmail(ticket);
      if (!email) {
        orderError.value = 'Email non disponibile per questo utente.';
        showOrderModal.value = true;
        orderLoading.value = false;
        selectedOrder.value = null;
        return;
      }

      return openLastOrder({
        uid: ticket.userId,
        email
      });
    };

    const ticketOrderBadgeStatus = (ticket) => orderBadgeStatus({
      uid: ticket.userId,
      email: ticketOrderEmail(ticket)
    });

    const formatEmail = (email) => {
      const value = (email || '').trim();
      if (!value) return '—';
      if (value.length <= 24) return value;
      return `${value.slice(0, 22)}…`;
    };

    const ticketStatusClass = (ticket) => ({
      green: ticket.status === 'Risposto',
      yellow: ticket.status === 'Non Risposto',
      orange: ticket.status === 'Aperto',
      red: ticket.status === 'Completato',
      'technical-ticket-blocked': ticket.status === 'Bloccato'
    });

    const ticketDateFormatter = new Intl.DateTimeFormat('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
      timeZone: 'Europe/Rome'
    });

    const formatTicketDate = (value) => {
      const date = toDateValue(value);
      return date ? ticketDateFormatter.format(date) : 'Data non disponibile';
    };

    const prefetchedOrderEmails = new Set();



    const stats = ref({
      aperto: 0,
      risposto: 0,
      nonRisposto: 0
    });

    const store = useStore();
    const userRole = ref(store.getters.userRole);
    const operatorStudio = ref(store.getters.userStudio);
    const filterByStatus = ref(store.getters.filterByStatus || 'Aperto');
    const filterByStudio = ref(store.getters.filterByStudio || '');
    const selectedTickets = ref([]);

    const functions = getFunctions();

    watch(filterByStatus, (newValue) => {
      store.dispatch('updateFilterByStatus', newValue);
    });

    watch(filterByStudio, (newValue) => {
      store.dispatch('updateFilterByStudio', newValue);
    });

    const debounce = (fn, delay) => {
      let timeoutID;
      return function (...args) {
        if (timeoutID) {
          clearTimeout(timeoutID);
        }
        timeoutID = setTimeout(() => {
          fn(...args);
        }, delay);
      };
    };

    const createTicket = async () => {
      if (isCreatingTicket.value) return;
      if (!selectedUser.value || !message.value || !title.value) {
        alert("Seleziona un cliente, inserisci un titolo e scrivi un messaggio prima di inviare.");
        return;
      }

      const userId = selectedUser.value.uid;
      const draftKey = JSON.stringify([userId, title.value, message.value]);
      if (pendingTicketDraft?.key !== draftKey) {
        pendingTicketDraft = { key: draftKey, messageId: createTechnicalMessageId() };
      }
      isCreatingTicket.value = true;

      try {
        const result = await createTechnicalTicket({ userId, title: title.value, content: message.value, messageId: pendingTicketDraft.messageId });
        if (result.created === false && !result.message) {
          alert('Questo utente ha già una conversazione esistente. Apro il ticket.');
          closeClientModal();
          router.push({ name: 'AssistenzaTecnicaConversation', params: { ticketId: result.ticketId } });
          return;
        }
        if (!result.duplicate) await sendNotification(userId);
        console.log('Ticket creato con successo! ID:', result.ticketId);
        alert("Messaggio inviato con successo!");
        closeClientModal();
      } catch (error) {
        console.error('Errore nella creazione del ticket:', error);
        alert("Errore nell'invio del messaggio. Riprova.");
      } finally {
        isCreatingTicket.value = false;
      }
    };

    const checkExistingTicket = async (userId) => {
      const ticketsCollection = collection(db, 'assistenzatecnica');
      const ticketsQuery = query(ticketsCollection, where('userId', '==', userId), where('status', 'in', ['Aperto', 'Non Risposto']));
      const ticketsSnapshot = await getDocs(ticketsQuery);
      const exists = !ticketsSnapshot.empty;
      console.log(`Ticket esistente per l'utente ${userId}: ${exists}`);
      return exists;
    };

    const selectUser = (user) => {
      selectedUser.value = user;
    };

    const fetchUsers = async () => {
      const usersCollection = collection(db, 'users');
      const userSnapshot = await getDocs(usersCollection);
      const allUsers = userSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      users.value = allUsers.filter(user => {
        const matchesEmail = debouncedSearchClientEmail.value.trim() === '' || (user.email && user.email.toLowerCase().includes(debouncedSearchClientEmail.value.toLowerCase()));
        const matchesSurname = debouncedSearchClientSurname.value.trim() === '' || (user.surname && user.surname.toLowerCase().includes(debouncedSearchClientSurname.value.toLowerCase()));
        return matchesEmail && matchesSurname;
      });
    };

    const onSearchClick = () => {
      fetchUsers();
    };

    const openClientModal = () => {
      showModal2.value = true;
    };

    const closeClientModal = () => {
      showModal2.value = false;
      selectedUser.value = null;
      title.value = '';
      message.value = '';
      pendingTicketDraft = null;
    };

    const openLinksModal = () => {
      showLinksModal.value = true;
    };

    const closeLinksModal = () => {
      showLinksModal.value = false;
    };

    const openStatsModal = () => {
      calculateStats();
      showStatsModal.value = true;
    };

    const closeStatsModal = () => {
      showStatsModal.value = false;
    };

    const calculateStats = () => {
      stats.value = {
        aperto: tickets.value.filter(ticket => ticket.status === 'Aperto').length,
        risposto: tickets.value.filter(ticket => ticket.status === 'Risposto').length,
        nonRisposto: tickets.value.filter(ticket => ticket.status === 'Non Risposto').length
      };
    };

    const searchByDate = async () => {
      if (searchDate.value) {
        const dayStart = new Date(searchDate.value);
        dayStart.setHours(0, 0, 0, 0);
        const dayEnd = new Date(searchDate.value);
        dayEnd.setHours(23, 59, 59, 999);

        const startTimestamp = Timestamp.fromDate(dayStart);
        const endTimestamp = Timestamp.fromDate(dayEnd);

        const ticketsQuery = query(
          collection(db, "assistenzatecnica"),
          where("timestamp", ">=", startTimestamp),
          where("timestamp", "<=", endTimestamp)
        );
        const querySnapshot = await getDocs(ticketsQuery);
        tickets.value = querySnapshot.docs.map(doc => ({
          ...doc.data(),
          id: doc.id
        }));
      }
    };

    const resetSearch = () => {
      searchDate.value = '';
      fetchTickets();
    };

    const viewConversation = async (ticketId) => {
      const displayedTicket = tickets.value.find((ticket) => ticket.id === ticketId);
      if (displayedTicket) {
        const displayedMessages = displayedTicket.conversations;
        const displayedLength = displayedMessages.length;
        const displayedLastKey = buildTechnicalMessageKey(displayedMessages[displayedLength - 1], displayedLength - 1);
        const ticketDocRef = doc(db, 'assistenzatecnica', ticketId);
        await runTransaction(db, async (transaction) => {
          const snapshot = await transaction.get(ticketDocRef);
          if (!snapshot.exists()) return;
          const latestMessages = Array.isArray(snapshot.data().conversations) ? snapshot.data().conversations : [];
          const latestLength = latestMessages.length;
          if (latestLength !== displayedLength
            || buildTechnicalMessageKey(latestMessages[latestLength - 1], latestLength - 1) !== displayedLastKey) return;
          transaction.update(ticketDocRef, { read: true, readAt: serverTimestamp() });
        });
      }
      router.push({ name: 'AssistenzaTecnicaConversation', params: { ticketId } });
    };

    onBeforeUnmount(() => {
      unsubscribeFns.forEach((fn) => fn && fn());
      unsubscribeFns.length = 0;

      if (userFetchTimeout) {
        clearTimeout(userFetchTimeout);
        userFetchTimeout = null;
      }
    });

    const goToUsers = () => {
      router.push('/users-list');
    };

    const refreshSlot = () => {
      window.location.reload();
    };

    const viewUserDetails = (userId) => {
      router.push({ name: 'UserDetails', params: { userId: userId } });
    };

    const openFiltriContactModal = () => {
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
    };

    const resetFilters = () => {
      searchEmail.value = '';
      searchSurname.value = '';
      filterByStudio.value = '';
      filterByStatus.value = '';
      store.dispatch('updateFilterByStudio', '');
      store.dispatch('updateFilterByStatus', 'Aperto');
      filterByMultipleTickets.value = false;
            filterByTipoTicket.value = '';

    };

    const fetchFilteredTickets = async () => {
      await fetchTickets();
    };

    

    const fetchTickets = async () => {
      isLoading.value = true;

      unsubscribeFns.forEach((fn) => fn && fn());
      unsubscribeFns.length = 0;

      tickets.value = [];
      const queryTicketIds = {
        open: new Set(),
        flagged: new Set()
      };
      const initializedQueries = new Set();

      const ticketsCollection = collection(db, 'assistenzatecnica');

      const sortTickets = () => {
        tickets.value.sort((a, b) => {
          if (a.flagged && !b.flagged) return -1;
          if (!a.flagged && b.flagged) return 1;
          if (a.flagged && b.flagged) {
            return (b.lastUpdateMs || 0) - (a.lastUpdateMs || 0);
          }
          return (a.lastUpdateMs || 0) - (b.lastUpdateMs || 0);
        });
      };

      const upsertTicket = (ticketId, ticketData) => {
        const conversations = Array.isArray(ticketData.conversations) ? ticketData.conversations : [];
        const lastUpdateMs = getTicketLastActivityMs(ticketData);

        const userData = userCache.get(ticketData.userId);

        const formattedTicket = {
          ...ticketData,
          id: ticketId,
          conversations,
          tipoTicket: ticketData.tipoTicket || '',
          flagged: !!ticketData.flagged,
          lastUpdate: lastUpdateMs ? formatTicketDate(lastUpdateMs) : 'Data non disponibile',
          lastUpdateMs,
        };

        const existingTicketIndex = tickets.value.findIndex((ticket) => ticket.id === ticketId);

        if (existingTicketIndex === -1) {
          const newTicket = {
            ...formattedTicket,
            userEmail: userData?.email || 'Caricamento...',
            userName: userData?.name || 'Caricamento...',
            userSurname: userData?.surname || '',
            userStudio: userData?.studio || '',
          };
          tickets.value.push(newTicket);
          if (userData?.email) {
            queueOrderPrefetch(ticketData.userId, userData.email);
          }
        } else {
          const existingTicket = tickets.value[existingTicketIndex];
          const updatedTicket = {
            ...existingTicket,
            ...formattedTicket,
          };

          if (userData) {
            updatedTicket.userEmail = userData.email || 'Email sconosciuta';
            updatedTicket.userName = userData.name || 'Nome sconosciuto';
            updatedTicket.userSurname = userData.surname || 'Cognome sconosciuto';
            updatedTicket.userStudio = userData.studio || 'Studio sconosciuto';
            if (userData.email) {
              queueOrderPrefetch(ticketData.userId, userData.email);
            }
          }

          tickets.value[existingTicketIndex] = updatedTicket;

          if (!userData && (!existingTicket.userEmail || existingTicket.userEmail === 'Caricamento...')) {
            enqueueUserDetailFetch(ticketData.userId);
            return;
          }
        }

        if (!userData) {
          enqueueUserDetailFetch(ticketData.userId);
        }
      };

      const removeTicket = (ticketId) => {
        tickets.value = tickets.value.filter((ticket) => ticket.id !== ticketId);
      };

      const handleSnapshot = (source, querySnapshot) => {
        const sourceTicketIds = queryTicketIds[source];
        for (const change of querySnapshot.docChanges()) {
          const ticketId = change.doc.id;

          if (change.type === 'removed') {
            sourceTicketIds.delete(ticketId);
            // Leaving one query does not remove a ticket still present in the other.
            if (!Object.values(queryTicketIds).some((ids) => ids.has(ticketId))) {
              removeTicket(ticketId);
            }
            continue;
          }

          sourceTicketIds.add(ticketId);
          upsertTicket(ticketId, change.doc.data());
        }

        sortTickets();
        initializedQueries.add(source);
        isLoading.value = initializedQueries.size < Object.keys(queryTicketIds).length;
      };

      try {
        const openTicketsQuery = query(ticketsCollection, where('status', '==', 'Aperto'));
        const flaggedTicketsQuery = query(ticketsCollection, where('flagged', '==', true));

        const unsubscribeOpen = onSnapshot(openTicketsQuery, (snapshot) => handleSnapshot('open', snapshot), (error) => {
          console.error('Errore snapshot ticket aperti:', error);
          initializedQueries.add('open');
          isLoading.value = initializedQueries.size < Object.keys(queryTicketIds).length;
        });
        const unsubscribeFlagged = onSnapshot(flaggedTicketsQuery, (snapshot) => handleSnapshot('flagged', snapshot), (error) => {
          console.error('Errore snapshot ticket flaggati:', error);
          initializedQueries.add('flagged');
          isLoading.value = initializedQueries.size < Object.keys(queryTicketIds).length;
        });

        unsubscribeFns.push(unsubscribeOpen, unsubscribeFlagged);
      } catch (error) {
        console.error('Errore nel caricamento dei ticket:', error);
        isLoading.value = false;
      }
    };
const fetchUserDetails = async () => {
  const usersCollection = collection(db, 'users');
  try {
    const userSnapshot = await getDocs(usersCollection);
    const userDetails = {};

    userSnapshot.forEach(doc => {
      const userData = doc.data();
      userDetails[doc.id] = {
        email: userData.email,
        name: userData.name,
        surname: userData.surname,
        studio: userData.studio,
        uid: userData.uid,
      };
    });

    return userDetails;
  } catch (error) {
    console.error('Errore nel recupero dei dettagli utente:', error);
    return {};
  }
};



    const confirmSendNotification = async (userId) => {
      const confirmSend = confirm("Sei sicuro di voler inviare una notifica?");
      if (confirmSend) {
        sendNotification(userId);
      }
    };

    const confirmSendNotificationsToSelected = async () => {
      const confirmSend = confirm("Sei sicuro di voler inviare notifiche agli utenti selezionati?");
      if (confirmSend) {
        sendNotificationsToSelected();
      }
    };

    const sendNotificationsToSelected = async () => {
      for (const ticketId of selectedTickets.value) {
        const ticket = tickets.value.find(t => t.id === ticketId);
        if (ticket) {
          try {
            await sendNotification(ticket.userId);
          } catch (error) {
            console.error(`Errore durante l'invio della notifica per l'utente ${ticket.userId}:`, error);
          }
        }
      }
      alert('Notifiche inviate con successo!');
      selectedTickets.value = [];
    };

    const sendNotification = async (userId) => {
      try {
        const sendNotificationFunction = httpsCallable(functions, 'sendNotificationAndEmail');
        await sendNotificationFunction({ userId });
        console.log('Notifica inviata con successo per l\'utente:', userId);
      } catch (error) {
        console.error('Errore durante l\'invio della notifica:', error);
      }
    };

    const updateTicketStatus = async (ticket) => {
      try {
        const ticketDocRef = doc(db, 'assistenzatecnica', ticket.id);
        await updateDoc(ticketDocRef, { status: ticket.status });
        alert('Stato del ticket aggiornato con successo!');
      } catch (error) {
        console.error('Errore durante l\'aggiornamento dello stato del ticket:', error);
        alert('Errore durante l\'aggiornamento dello stato del ticket. Riprova.');
      }
    };



    const updateTipoTicket = async (ticket, event) => {
      const activeTicketId = ticket.id;
      if (ticketTypeSaving.value[activeTicketId]) return;
      const selectedType = event.target.value;
      const previousType = ticket.tipoTicket || '';
      const ticketDocRef = doc(db, 'assistenzatecnica', activeTicketId);
      ticketTypeSaving.value[activeTicketId] = true;
      delete ticketTypeErrors.value[activeTicketId];
      try {
        await updateDoc(ticketDocRef, { tipoTicket: selectedType });
      } catch (error) {
        console.error('Errore durante l\'aggiornamento della tipologia del ticket:', error);
        const currentTicket = tickets.value.find(row => row.id === activeTicketId);
        if (currentTicket && currentTicket.tipoTicket === selectedType) currentTicket.tipoTicket = previousType;
        try {
          const snapshot = await getDoc(ticketDocRef);
          const liveTicket = tickets.value.find(row => row.id === activeTicketId);
          // A newer live snapshot supersedes this error-recovery read.
          if (snapshot.exists() && liveTicket && liveTicket === currentTicket) liveTicket.tipoTicket = snapshot.data().tipoTicket || '';
        } catch (reloadError) {
          console.error('Errore nel recupero della tipologia del ticket:', reloadError);
        }
        ticketTypeErrors.value[activeTicketId] = 'Tipologia non salvata. Riprova.';
      } finally {
        delete ticketTypeSaving.value[activeTicketId];
      }
    };




    const selectAllVisibleTickets = () => {
      selectedTickets.value = filteredTickets.value.map(ticket => ticket.id);
    };

    const confirmDeleteSelectedTickets = async () => {
      const confirmDelete = confirm("Sei sicuro di voler eliminare i ticket selezionati?");
      if (confirmDelete) {
        await deleteSelectedTickets();
      }
    };

    const deleteSelectedTickets = async () => {
      try {
        const deletePromises = selectedTickets.value.map(ticketId => deleteDoc(doc(db, 'assistenzatecnica', ticketId)));
        await Promise.all(deletePromises);
        alert("I ticket selezionati sono stati eliminati con successo.");
        selectedTickets.value = [];
        fetchTickets();
      } catch (error) {
        console.error("Errore durante l'eliminazione dei ticket selezionati:", error);
        alert("Errore durante l'eliminazione dei ticket selezionati. Riprova.");
      }
    };

    const filteredTickets = computed(() => {
      const userTicketCounts = tickets.value.reduce((acc, ticket) => {
        acc[ticket.userId] = (acc[ticket.userId] || 0) + 1;
        return acc;
      }, {});

      const filteredList = tickets.value.filter((ticket) => {
        const isFlagged = !!ticket.flagged;
        const matchesEmail = searchEmail.value ? (ticket.userEmail && ticket.userEmail.toLowerCase().includes(searchEmail.value.toLowerCase())) : true;
        const matchesSurname = searchSurname.value ? (ticket.userSurname && ticket.userSurname.toLowerCase().includes(searchSurname.value.toLowerCase())) : true;
            const matchTipoTicket = !filterByTipoTicket.value || ticket.tipoTicket === filterByTipoTicket.value;

        const matchesStudio = filterByStudio.value === 'undefined' ? 
                              (!ticket.userStudio || ticket.userStudio === 'undefined') :
                              filterByStudio.value ? ticket.userStudio === filterByStudio.value : true;
        let matchesStatus = true;
        if (filterByStatus.value) {
          if (isFlagged) {
            matchesStatus = true;
          } else if (filterByStatus.value === 'Non Risposto') {
            matchesStatus = ticket.status === 'Non Risposto';
          } else if (filterByStatus.value === 'Aperto') {
            matchesStatus = ticket.status === 'Aperto';
          } else if (filterByStatus.value === 'Risposto') {
            matchesStatus = ticket.status === 'Risposto';
          } else {
            matchesStatus = ticket.status === filterByStatus.value;
          }
        }
        const matchesMultipleTickets = filterByMultipleTickets.value ? userTicketCounts[ticket.userId] > 1 : true;
        const matchesKeyword = searchKeyword.value ? ticket.conversations.some(convo => String(convo?.content || '').toLowerCase().includes(searchKeyword.value.toLowerCase())) : true;
        return matchesEmail && matchesSurname && matchesStudio && matchesStatus && matchesMultipleTickets && matchesKeyword && matchTipoTicket;
      });

      return filteredList;
    });


// chiamata quando cambia il select tipoTicket nel modal
    const updateFilterByTipoTicket = () => {
      // NON serve riassegnare nulla: il computed reagisce automaticamente
      console.log('Filtro tipo ticket impostato su:', filterByTipoTicket.value)
    }



    const filteredUsers = computed(() => {
      return users.value.filter((user) => {
        const matchesEmail = user.email && user.email.toLowerCase().includes(debouncedSearchClientEmail.value.toLowerCase());
        const matchesSurname = user.surname && user.surname.toLowerCase().includes(debouncedSearchClientSurname.value.toLowerCase());
        return matchesEmail && matchesSurname;
      });
    });

    onMounted(fetchTickets);

    watch([searchClientEmail, searchClientSurname], debounce(() => {
      debouncedSearchClientEmail.value = searchClientEmail.value;
      debouncedSearchClientSurname.value = searchClientSurname.value;
      fetchUsers();
    }, 500));

    return {
      tickets,
      viewConversation,
      selectedTypes: ref({}),
      isLoading,
      filteredTickets,
      resetFilters,
      fetchFilteredTickets,
      searchEmail,
      searchSurname,
      filterByStudio,
      filterByStatus,
      filterByMultipleTickets,
      searchKeyword,
      openFiltriContactModal,
      closeModal,
      showModal,
      showModal2,
      openClientModal,
      closeClientModal,
      showLinksModal,
      openLinksModal,
      closeLinksModal,
      showStatsModal,
      openStatsModal,
      closeStatsModal,
      stats,
      calculateStats,
      users,
      selectedUser,
      title,
      message,
      viewUserDetails,
      refreshSlot,
      searchDate,
      searchByDate,
      resetSearch,
      fetchUsers,
      selectUser,
      createTicket,
      isCreatingTicket,
      checkExistingTicket,
      searchClientEmail,
      searchClientSurname,
      debouncedSearchClientEmail,
      debouncedSearchClientSurname,
      filteredUsers,
      operatorStudio,
      userRole,
      onSearchClick,
      confirmSendNotification,
      confirmSendNotificationsToSelected,
      selectedTickets,
      sendNotificationsToSelected,
      updateTicketStatus,
      selectAllVisibleTickets,
      confirmDeleteSelectedTickets,
      deleteSelectedTickets,
      goToUsers,
      fetchUserDetails,
      updateTipoTicket,
      ticketTypeSaving,
      ticketTypeErrors,
      filterByTipoTicket,
      updateFilterByTipoTicket,
      showOrderModal,
      orderLoading,
      orderError,
      selectedOrder,
      orderSummary,
      showTicketOrder,
      closeOrderModal,
      ticketOrderBadgeStatus,
      productHighlightClass,
      formatEmail,
      ticketStatusClass,
      ticketProgrammeStatus
    };
  },
};
</script>




<style scoped>
.technical-ticket-category-feedback {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #64748b;
}

.technical-ticket-category-feedback--error {
  color: #b91c1c;
}

.create-user-button2 {
  padding: 13px 15px;
  border-radius: 13px;
  background-color: #f2a100;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  border: none;
  text-align: center; /* Centra il testo orizzontalmente */
  display: inline-flex; /* Assicura che l'allineamento al centro funzioni correttamente */
  align-items: center; /* Centra verticalmente il contenuto */
  justify-content: center; /* Centra orizzontalmente il contenuto */
}
.data-column {
  width: 400px;
  font-size: 12px;
}

.technical-ticket-state-cell {
  min-width: 120px;
}

.technical-ticket-programme-cell {
  min-width: 110px;
}

.technical-ticket-programme {
  display: block;
  width: fit-content;
  margin: 3px 0;
  padding: 5px 9px;
  border-radius: 8px;
  background: #e2e8f0;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.technical-ticket-programme--active {
  background: #dcfce7;
  color: #166534;
}

.technical-ticket-programme--expired {
  background: #fee2e2;
  color: #991b1b;
}

.technical-ticket-programme--waiting,
.technical-ticket-programme--review {
  background: #fef3c7;
  color: #92400e;
}

.technical-ticket-programme--hold {
  background: #ede9fe;
  color: #5b21b6;
}

.technical-ticket-state {
  display: inline-block;
  padding: 5px 9px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
}

.technical-ticket-state.green {
  background: #dcfce7;
  color: #166534;
}

.technical-ticket-state.yellow {
  background: #fef9c3;
  color: #854d0e;
}

.technical-ticket-state.orange {
  background: #ffedd5;
  color: #9a3412;
}

.technical-ticket-state.red {
  background: #fee2e2;
  color: #991b1b;
}

.technical-ticket-blocked {
  background: #e2e8f0;
  color: #334155;
}

.technical-ticket-read-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 5px;
  color: #6b21a8;
  font-size: 11px;
}

.technical-ticket-read-indicator .material-icons {
  color: inherit;
  font-size: 14px;
}

.technical-ticket-read-indicator--unread {
  color: #475569;
}

/* Stili esistenti */
.buttons-container {
  display: flex;
  gap: 10px; /* Spazio tra i bottoni */
  align-items: center; /* Allinea gli elementi verticalmente al centro */
}

.buttons-container button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
}

/* Stili per i checkbox */
.custom-checkbox {
  width: 20px;  /* Larghezza del checkbox */
  height: 20px; /* Altezza del checkbox */
  margin: 0;    /* Margine */
  cursor: pointer; /* Cursor pointer per l'interazione */
}

.custom-checkbox:checked {
  background-color: #4CAF50; /* Colore di sfondo quando è selezionato */
  border: 2px solid #4CAF50; /* Bordo quando è selezionato */
}

.custom-checkbox:focus {
  outline: none; /* Rimuove il bordo di messa a fuoco */
}

.flagged-ticket {
  background-color: #fff6da;
}

.flag-indicator {
  display: inline-block;
  margin-top: 6px;
  padding: 2px 8px;
  background-color: #f2a100;
  color: #fff;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.order-column {
  width: 80px;
}

.order-cell {
  text-align: center;
}

.order-badge {
  width: 34px;
  height: 34px;
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.4);
  background: #f7f9fc;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}

.order-badge .material-icons {
  font-size: 20px;
}

.order-badge:hover {
  background: #e0e7ff;
  border-color: rgba(99, 102, 241, 0.55);
  color: #4338ca;
  transform: translateY(-1px);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.12);
}

.order-badge--green {
  border: none;
  background: linear-gradient(120deg, #22c55e, #16a34a);
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(34, 197, 94, 0.32);
}

.order-badge--green:hover {
  background: linear-gradient(120deg, #22c55e, #16a34a);
  border: none;
  box-shadow: 0 18px 40px rgba(34, 197, 94, 0.36);
  color: #ffffff;
}

.order-badge--orange {
  border: none;
  background: linear-gradient(120deg, #f97316, #ea580c);
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(249, 115, 22, 0.28);
}

.order-badge--orange:hover {
  background: linear-gradient(120deg, #f97316, #ea580c);
  border: none;
  box-shadow: 0 18px 40px rgba(234, 88, 12, 0.32);
  color: #ffffff;
}

.order-badge--neutral {
  background: #f8fafc;
  border-color: rgba(148, 163, 184, 0.45);
}

.email-cell {
  max-width: 240px;
}

.email-text {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: #1f2937;
}

.order-card {
  background: linear-gradient(165deg, #f8fafc 0%, #e5ebf6 100%);
  border-radius: 20px;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.14);
  padding: 22px 24px;
  color: #0f172a;
}

.order-modal {
  width: min(520px, 92vw);
}

.order-loader,
.order-error,
.order-empty {
  margin-top: 12px;
  font-size: 0.95rem;
}

.order-error {
  color: #f87171;
}

.order-empty {
  color: #475569;
}

.order-card__body {
  display: grid;
  gap: 14px;
}

.order-field {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 8px 0;
  border-bottom: 1px solid rgba(148, 163, 184, 0.25);
}

.order-field:last-child {
  border-bottom: none;
}

.order-field__label {
  font-weight: 600;
  color: #475569;
}

.order-field__value {
  font-weight: 500;
  color: #0f172a;
}

.order-field--products {
  flex-direction: column;
  border-bottom: none;
}

.order-products {
  list-style: none;
  padding: 0;
  margin: 6px 0 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.order-product--green {
  color: #15803d;
  font-weight: 600;
}

.order-product--orange {
  color: #c2410c;
  font-weight: 600;
}

.order-product--neutral {
  color: #1e293b;
}

@media (max-width: 768px) {
  .staff-ticket-table .technical-ticket-state-cell {
    grid-column: 1 / -1;
    align-items: flex-start;
  }

  .staff-ticket-table .technical-ticket-programme-cell {
    grid-column: 1 / -1;
    align-items: flex-start;
  }

  .staff-ticket-table .staff-ticket-actions-cell .buttons-container button.technical-ticket-notification-action {
    background: #e2e8f0;
    color: #1e293b;
  }
}

</style>

<style scoped src="../../assets/css/staff-ticket-mobile.css"></style>
